<template>
  <div>
    <div v-if="isVisible" class="overlay" @click="close">
      <div class="modal" :class="{ fadeOut: isFadingOut }">
        <div class="chanpin">
          <img class="fudai_tuijain_chanpin_logo" src="@/assets/img/fudai_tuijain_chanpin_logo.png" />
          <div class="name">
          <h4>BRD</h4>
          <h6>Pinjaman Online Cepat</h6>
         </div>
        </div>
        <h5>Selamat</h5>
        <p>Menjadi pelanggan kredit tingg.</p>
        <p>Rekomendasikan produk eksklusif VP untukAnda.</p>
        <p>(Bunga rendah, Batas tinggi, Persetujuan cepat)</p>
        <button class="fudai_tuijain_chanpin_btn"  @click="close" >OKE</button>
      </div>
    </div>
    <div v-if="isVisible2" class="overlay" @click="close">
      <div class="modal" :class="{ fadeOut: isFadingOut }">
        <div class="chanpin">
          <img class="fudai_tuijain_chanpin_logo" :src="ProductInfo.product_logo"  />
          <div class="name">
            <h4>{{ ProductInfo.product_name }}</h4>
            <h6>{{ ProductInfo.product_title }}</h6>
         </div>
        </div>
        <h5>Selamat</h5>
        <p>
          Karena kredit Anda baik, kami akan membuka produk VIP ({{ ProductInfo.product_name }}) untuk Anda, dan Anda akan menikmatinya (suku bunga rendah, batas kredit tinggi), dan pinjaman akan diberikan secara langsung tanpa peninjauan.
        </p>
        <button class="fudai_tuijain_chanpin_btn" @click="$router.back()">Lanjutkan sekarang</button>
      </div>
    </div>
    <div class="advertising" v-show="advertisingShow" @click="goAdvertising">
      <img src="@/assets/img/advertising_close.png" @click="advertisingShow = false" />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  props: {
    redrpaymentTime: {
      type: String,
      default: ''
    },
    orderStatus: {
      type: Number,
      default: 0
    },
    redr_loan: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isVisible: false,
      isVisible2: false,
      isFadingOut: false,
      advertisingShow: true,
      ProductInfo: {}
    }
  },
  created () {
    this.ShowModal()
    this.getProductInfo()
  },
  methods: {
    ShowModal () {
      if (this.$props.orderStatus === 6 && this.$props.redr_loan === 1) {
        const tuijianOrderStatus6 = localStorage.getItem('fudai_tuijain_chanpin_orderStatus6')
        if (!tuijianOrderStatus6) {
          this.isVisible2 = true
        }
        localStorage.setItem('fudai_tuijain_chanpin_orderStatus6', true)
        return
      }
      if (this.$props.orderStatus === 5) {
        const tuijianOrderStatus5 = localStorage.getItem('fudai_tuijain_chanpin_orderStatus5')
        if (!tuijianOrderStatus5) {
          // 如果当前时间在到期时间或到期时间前一天，则返回 false
          const result = this.isCurrentTimeBeforeExpiration()
          if (result) {
            this.open()
          }
          localStorage.setItem('fudai_tuijain_chanpin_orderStatus5', true)
        }
      }
    },
    open () {
      this.isVisible = true
      this.isFadingOut = false
    },
    close () {
      this.isFadingOut = true
      setTimeout(() => {
        this.isVisible = false
      }, 1000) // 动画持续时间与 CSS 动画保持一致
    },
    // BRD
    goAdvertising () {
      window.location = `http://ojk.pasarpinjaman.cc/brd?tm=${Date.now()}`
    },
    // 判断是不是到期和到期前一天 如果是则不弹 否则弹框
    isCurrentTimeBeforeExpiration () {
      const expirationDate = this.convertDateFormat(this.$props.redrpaymentTime)
      // 获取当前时间戳
      const currentTimestamp = Date.now()
      // 转换到期时间为时间戳
      const expirationTimestamp = new Date(expirationDate).getTime()
      // 判断expirationTimestamp是不是NAN 如果是返回false
      if (isNaN(expirationTimestamp)) {
        return false
      }
      // 计算到期时间前一天的时间戳
      const oneDayInMillis = 24 * 60 * 60 * 1000 // 1天的毫秒数
      const expirationDayBeforeTimestamp = expirationTimestamp - oneDayInMillis
      // 判断当前时间是否在到期时间或到期时间前一天的范围内，或者当前时间是否已经超过到期时间
      if (currentTimestamp >= expirationDayBeforeTimestamp && currentTimestamp <= expirationTimestamp) {
        return false
      }
      // 判断当前时间是否已经超过到期时间
      if (currentTimestamp > expirationTimestamp) {
        return false
      }
      return true
    },
    // 将到期日'13/09/2024' 转换成2024-09-13
    convertDateFormat (dateStr) {
      const [day, month, year] = dateStr.split('/').map(Number)
      const date = new Date(Date.UTC(year, month - 1, day))
      const yearStr = date.getUTCFullYear()
      const monthStr = String(date.getUTCMonth() + 1).padStart(2, '0')
      const dayStr = String(date.getUTCDate()).padStart(2, '0')
      return `${yearStr}-${monthStr}-${dayStr}`
    },
    // 获取贷超页面第一个产品的信息
    getProductInfo () {
      request.post('marketHomepage').then(res => {
        this.ProductInfo = res.marketList[0]
      })
    }

  }
}
</script>

<style scoped lang="less">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  position: relative;
  width: 572px;
  height: 599px;
  transition: all 1s ease;
  background: url("~@/assets/img/fudai_tuijain_chanpin_bg.png");
  background-size: 100% 100%;
  p {
    padding: 0 20px;
      font-size: 25px;
      color: #7e7e7e;
      text-align: center;
      margin-bottom: 5px;
    }
    h5{
      font-weight: 500;
      font-size: 30px;
      text-align: center;
    }
  .chanpin {
    margin-top: 30px;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    .fudai_tuijain_chanpin_logo {
      width: 102px;
      height: 102px;
      border-radius: 50%;
      margin-right: 20px;
    }
  }

  .name {
    font-weight: 500;
    font-size: 30px;
    color: #000000;

    h6{
      font-size: 24px;
      color: #7e7e7e;
    }
  }

  .fudai_tuijain_chanpin_btn {
    background-color: #22aafd;
    min-width: 296px;
    margin: 0 auto;
    border-radius: 10px;
    border: none;
    color: #fff;
    font-size: 28px;
    padding: 20px 40px;
    margin-top: 70px;
  }
}

.fadeOut {
  // transform: translateY(100vh) scale(0); /* 从中间向下移动并缩小 */
  transform: translate(-49vw, 50vh) scale(0.1);
  /* 向左下角移动并缩小 */
  opacity: 0;
  /* 透明度降低 */
  width: 100px;
  height: 100px;
}

.advertising {
  height: 90px;
  width: 100%;
  position: fixed;
  bottom: 15px;
  left: 0;
  background: url("~@/assets/img/fudai_tuijain_chanpin_download.png") no-repeat;
  background-size: 100% 100%;

  img {
    position: absolute;
    width: 28px;
  }
}
</style>
